import { RestUrl } from "../../common/cyan.types";

export class EcoaAccessCodeUrl {
  public static verifyEcoaAccessCode: RestUrl = ["POST", "/ecoa/access/verify"];
}
